import { useEffect, useState, useCallback } from "react";
import { api } from "services/api.service";

export interface HomeStats {
  pickupsCount: number;
  locationsCount: number;
  ticketsCount: number;
}

export default function useHome() {
  const [isLoading, setIsLoading] = useState(true);
  const [home, setHome] = useState<HomeStats | null>(null);
  const [isError, setIsError] = useState(false);

  const refetch = useCallback(() => {
    setIsLoading(true);
    setIsError(false);
    api
      .get<{ home: HomeStats }>("/home")
      .then((res) => {
        setHome(res.data.home);
      })
      .catch(() => {
        setIsError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    home,
    isLoading,
    isError,
    refetch,
  };
}
